// SPDX-License-Identifier: SEE LICENSE
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import './styles.css';
import { AuthProvider, RequireAuth } from './auth';
import { Certificate } from './pages/Certificate';
import { PublicVerify } from './pages/PublicVerify';
import { Sessions } from './pages/Sessions';
import { SessionView } from './pages/SessionView';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Everything requires login — no session data or certificate is
              reachable without authentication, including the cert view. */}
          <Route path="/" element={<RequireAuth><Sessions /></RequireAuth>} />
          <Route path="/sessions/:id" element={<RequireAuth><SessionView /></RequireAuth>} />
          <Route
            path="/sessions/:id/certificate"
            element={<RequireAuth><Certificate /></RequireAuth>}
          />
          {/* PUBLIC single-cert verification (scanned QR) — one cert by its
              unguessable short-id, no login, nothing else exposed. */}
          <Route path="/verify/:short" element={<PublicVerify />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>,
);
